/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Create_Missing_DataInputs */

const vi_api_keys_create_missing_data = /** @type {(inputs: Api_Keys_Create_Missing_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo API key thành công nhưng máy chủ không trả về khoá — hãy thử lại hoặc kiểm tra danh sách khoá trước khi tạo thêm`)
};

/**

* @param {Api_Keys_Create_Missing_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_create_missing_data = /** @type {((inputs?: Api_Keys_Create_Missing_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Create_Missing_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_create_missing_data(inputs)
});